function CopyRights() {
  return (
    <div className='py-2 text-center border-t border-border text-muted-foreground dark:bg-gray-900 dark:text-gray-400 dark:border-gray-800'>
        <p>
            ©
            2025
             Parwinder Kaur. All rights reserved.
        </p>
    </div>
  )
}

export default CopyRights
